// Link zakupowy InterRisk EDU Plus (NNW szkolne) — program 2026/2027.
// Nowy identyfikator programu obowiązuje od 25.08.2026 (wcześniej: u=a3pgrd3kv5).
export const EDU_PLUS_BUY_LINK =
  'https://klient.interrisk.pl/EduPlusOnline?u=yzrjcxekx4';

export const getEduPlusBuyLink = () => EDU_PLUS_BUY_LINK;
